// extracted by mini-css-extract-plugin
export default {"mainWrapper":"ManageEachStaffWrapper_mainWrapper__hw0YL"};